import { Badge, CountryCode, FlagComponent } from '@commenda/kakashi';
import { IndirectTaxClientTaskHelper } from '@commenda/ui/indirect-tax/common/helpers';
import type { IIndirectTaxFilingReviewGroup } from '@commenda/ui/indirect-tax/common/types';
import { Country } from 'country-state-city';
import { ACTIVE_SERVICES_GRID_CLASSNAME } from './ActiveServicesRow';

interface FilingReviewRowProps {
  filingReviewGroup: IIndirectTaxFilingReviewGroup;
  onOpen: (filingReviewGroup: IIndirectTaxFilingReviewGroup) => void;
}

export const FilingReviewRow = ({
  filingReviewGroup,
  onOpen,
}: FilingReviewRowProps) => {
  const { corporationName, corporationCountry, filingCount } =
    filingReviewGroup;
  const title = IndirectTaxClientTaskHelper.getFilingReviewTitle(filingCount);

  return (
    <div
      role="button"
      tabIndex={0}
      onClick={() => onOpen(filingReviewGroup)}
      onKeyDown={(event) => {
        if (event.key === 'Enter' || event.key === ' ')
          onOpen(filingReviewGroup);
      }}
      className={`${ACTIVE_SERVICES_GRID_CLASSNAME} cursor-pointer border-b border-border-secondary py-md text-left transition-colors hover:bg-bg-secondary`}
    >
      <span
        title={title}
        className="truncate txt-small-regular text-text-primary"
      >
        {title}
      </span>

      <div className="flex items-center gap-md overflow-hidden">
        {corporationCountry && (
          <FlagComponent
            _className="size-5 shrink-0"
            // incorporationCountry stores ISO 3166-1 alpha-2 codes.
            country={corporationCountry as CountryCode}
            countryName={Country.getCountryByCode(corporationCountry)?.name}
          />
        )}
        <span className="truncate txt-small-regular text-text-primary">
          {corporationName}
        </span>
      </div>

      <div>
        <Badge variant="error" size="sm">
          Action required
        </Badge>
      </div>

      <span className="truncate txt-small-regular text-text-primary">You</span>
    </div>
  );
};
